import { connect } from 'react-redux';
import { getPOSData } from '@olxbr/mojo-jojo/selectors/pos';
import { getProductsData } from '@olxbr/mojo-jojo/selectors/products';
import { getLimitsData } from '@olxbr/mojo-jojo/selectors/limits';
import { getCurrentContent } from '@olxbr/mojo-jojo/selectors/content';
import { changeCurrentStep } from '@olxbr/mojo-jojo/actions/meta';
import { getAdData } from '@olxbr/mojo-jojo/selectors/ad';

import Subscription from './Subscription';


const mapDispatchToProps = { changeCurrentStep };
const mapStateToProps = state => ({
  posData: getPOSData(state),
  productsData: getProductsData(state),
  contentData: getCurrentContent(state),
  limitsData: getLimitsData(state),
  adData: getAdData(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Subscription);
